import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import SearchField from '../../../../../../../components/FormLegacy/FormFieldsV2/SearchField'
import Icon from '../../../../../../../components/Icons'
import { getCustomTasksFilterOptions } from '../../helpers'

const CustomTasksNavbar = ({
  search,
  selectedTab,
  setSearch = () => {},
  setSelectedTab = () => {},
}) => {
  const { t } = useTranslation(['checklists-settings'])
  const customTasksFilterOptions = getCustomTasksFilterOptions(t)
  return (
    <div className="ctp-checklists-wrapper-navbar">
      <div className="single-row">
        <div className="left-side">
          {customTasksFilterOptions.map((tabFilter) => (
            <div
              className={`message-type-filter ${
                selectedTab && tabFilter.id === selectedTab.id ? 'active' : ''
              }`}
              key={tabFilter.id}
              onClick={() => setSelectedTab(tabFilter)}
            >
              {tabFilter.text}
            </div>
          ))}
        </div>
        <div className="right-side">
          <SearchField
            placeholder={t('checklists-settings:shared.searchTaskNamePlaceholder')}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button
            className="button button-black-outline"
            // onClick={openCreateNewTask}
            // disabled={!selectedBuilding}
          >
            <Icon icon="circleQuestion" />
            {t('checklists-settings:customTasks.howToSetupTasksButton')}
          </button>
        </div>
      </div>
    </div>
  )
}

CustomTasksNavbar.propTypes = {
  search: PropTypes.string,
  statusFilters: PropTypes.array,
  setSearch: PropTypes.func,
  setSelectedTab: PropTypes.func,
  selectedTab: PropTypes.object,
}

export default CustomTasksNavbar
